module.exports = __webpack_public_path__ + "img/p12.152c3798.png";